import { useDispatch, useSelector } from "react-redux";
import API_SERVICE from "../../../utils/apiService";
import { useEffect, useState } from "react";
import { Button, Checkbox, FormControl, Modal, ModalDialog, Stack, Typography } from "@mui/joy";
import { setEditPlaceId, setPlaces, setShowEditPlaceModal } from "../../../store";
import TextInput from "../../common/TextInput";

function EditPlaceModal() {
  const dispatch = useDispatch();
  const showModal = useSelector((state) => state.modal.showEditPlaceMmodal);

  const chosenPlaceId = useSelector((state) => state.place.editPlaceId);
  const [placeData, setPlaceData] = useState(null);

  // values for existing entry in modal
  const [corkageFee, setCorkageFee] = useState(null);
  const [acceptsReservations, setAcceptsReservations] = useState(null);
  const [hasWineGlasses, setHasWineGlasses] = useState(null);
  const [notes, setNotes] = useState(null);
  const [hasBottleLimit, setHasBottleLimit] = useState(null);
  const [bottleLimit, setBottleLimit] = useState(null);

  useEffect(() => {
    if (chosenPlaceId === null) {
      setPlaceData(null);
      return;
    }
    const populatePlaceData = async () => {
      const dataResponse = await API_SERVICE.getPlace(chosenPlaceId);
      setPlaceData(dataResponse);
      setCorkageFee(dataResponse.corkageFee);
      setAcceptsReservations(dataResponse.acceptsReservations);
      setHasWineGlasses(dataResponse.hasWineGlasses);
      setNotes(dataResponse.notes);
      setHasBottleLimit(dataResponse.bottleLimit ? true : false);
      setBottleLimit(dataResponse.bottleLimit);
    };
    populatePlaceData();
  }, [chosenPlaceId]);

  const mapBounds = useSelector((state) => state.map.mapBounds);
  const acceptsReservationsFilter = useSelector(
    (state) => state.filter.acceptsReservations,
  );
  const hasWineGlassesFilter = useSelector(
    (state) => state.filter.hasWineGlasses,
  );
  async function resetData() {
    setPlaceData(null);
    setCorkageFee(null);
    setAcceptsReservations(null);
    setHasWineGlasses(null);
    setNotes(null);
    setHasBottleLimit(null);
    setBottleLimit(null);
    dispatch(setEditPlaceId(null));
    // refresh the placeData on the map-marker & list-item
    const markerList = await API_SERVICE.searchPlaces(
      mapBounds,
      acceptsReservationsFilter,
      hasWineGlassesFilter,
    );
    dispatch(setPlaces(markerList));
  }

  return (
    <Modal
      open={showModal}
      onClose={() => dispatch(setShowEditPlaceModal(false))}
    >
      <ModalDialog sx={{
        overflowY: "auto",
      }}>
        {placeData && (
          <>
            <Stack spacing={-0.5}>
              <Typography level="h4" fontWeight="bold">
                {placeData["name"]}
              </Typography>
              <Typography level="body-sm">
                {placeData["formattedAddress"]}
              </Typography>
              <Typography level="body-sm">
                {placeData["formattedPhoneNumber"]}
              </Typography>
            </Stack>
            <form
              onSubmit={async (event) => {
                event.preventDefault();
                dispatch(setShowEditPlaceModal(false));
                await API_SERVICE.updatePlace(
                  chosenPlaceId,
                  corkageFee,
                  acceptsReservations,
                  hasWineGlasses,
                  notes,
                  hasBottleLimit ? bottleLimit : null,
                );
                resetData();
              }}
            >
              <Stack spacing={2}>
                <Stack spacing={0}>
                  <Typography level="title-sm" fontWeight={700} sx={{ mb: 0.5 }}>
                    Corkage Fee
                  </Typography>
                  <TextInput
                    value={corkageFee}
                    onChange={(event) => setCorkageFee(event.target.value)}
                    startDecorator={"$"}
                    endDecorator={<Typography level="body-sm">per bottle</Typography>}
                  />
                </Stack>
                <FormControl>
                  <Checkbox
                    label="Bottle Limit?"
                    checked={hasBottleLimit}
                    onChange={(_e) => setHasBottleLimit(!hasBottleLimit)}
                  />
                </FormControl>
                <Stack spacing={0}>
                  <Typography level="title-sm" fontWeight={700} sx={{ mb: 0.5 }}>
                    Bottle Limit (Optional)
                  </Typography>
                  <TextInput
                    disabled={!hasBottleLimit}
                    value={bottleLimit}
                    onChange={(event) => setBottleLimit(event.target.value)}
                    type="number"
                    min={1}
                  />
                </Stack>
                <Stack spacing={0}>
                  <Typography level="title-sm" fontWeight={700} sx={{ mb: 0.5 }}>
                    Corkage Notes (Optional)
                  </Typography>
                  <TextInput
                    value={notes}
                    onChange={(event) => {
                      if (event.target.value === "") {
                        setNotes(null);
                      }
                      setNotes(event.target.value);
                    }}
                  />
                </Stack>
                <Stack spacing={1}>
                  <Typography level="title-sm" fontWeight={700} sx={{ mb: 0.5 }}>
                    Other Information
                  </Typography>
                  <Checkbox
                    label="Accepts Reservations"
                    checked={acceptsReservations}
                    onChange={(_e) => setAcceptsReservations(!acceptsReservations)}
                    size="sm"
                    color="neutral"
                  />
                  <Checkbox
                    label="Has Wine Glasses"
                    checked={hasWineGlasses}
                    onChange={(_e) => setHasWineGlasses(!hasWineGlasses)}
                    size="sm"
                    color="neutral"
                  />
                </Stack>
                <Button
                  type="submit"
                  sx={{
                    borderRadius: '24px',
                    backgroundColor: '#202030',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: '#F0B27A',
                    },
                  }}
                >
                  Update
                </Button>
              </Stack>
            </form>
          </>
        )}
      </ModalDialog>
    </Modal>
  );
}

export default EditPlaceModal;
